import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import CountryFlag from './CountryFlag'
import { SET_FILTERS } from 'dealer-reducers/src/redux/tableToolsReducer'
import NewSelect from './NewSelect'
import { useTranslation } from 'react-i18next'

const CountrySelector = (): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab])
  const availableCountries = useSelector(
    (state: RootReducer) => state.offersListReducer[currentTab].available_countries ?? []
  )
  const availableCountriesOptions = useMemo(() => {
    const uniqueCountries = [...new Set([...(availableCountries ?? []), filters.country_code])].filter(
      (item): item is string => typeof item === 'string' && item.length > 0
    )
    return uniqueCountries.map((item) => ({
      optionVal: item,
      optionLabel: item?.toLocaleUpperCase(),
      optionIcon: () => <CountryFlag width={14} height={10} countryCode={item} />
    }))
  }, [availableCountries, filters.country_code])

  return (
    <div>
      <NewSelect
        value={filters.country_code}
        onChange={(val) => {
          dispatch(SET_FILTERS({ ...filters, country_code: val as string, tab: currentTab }))
        }}
        label={t('country')}
        options={availableCountriesOptions}
      />
    </div>
  )
}

export default CountrySelector
